import { ItemModel } from 'models/Item/Item';
import { ListingModel } from 'models/Listing/Listing';
import { ScrapesiteModel } from 'models/scrapejob/ScrapesiteModel';
import { RawScrapejobDetailData } from './types';
import { formatDateTime } from 'utils/date';
import { ProcessStatus } from 'models/types';

export class ScrapejobModel {
  id: string;
  startTime: string;
  endTime: string;
  status: ProcessStatus;
  site: ScrapesiteModel | string;
  siteId: string;
  siteImage: string;
  items: ItemModel[];
  listings: ListingModel[];

  constructor(rawScrapejobData: RawScrapejobDetailData) {
    this.id = rawScrapejobData.id;
    this.startTime = rawScrapejobData.start_time;
    this.endTime = rawScrapejobData.end_time;
    this.status = rawScrapejobData.status;

    // Handle site being either a string (site ID) or a site object
    if (typeof rawScrapejobData.site === 'string') {
      this.site = rawScrapejobData.site;
      this.siteId = rawScrapejobData.site_id;
      this.siteImage = '';
    } else {
      this.site = new ScrapesiteModel(rawScrapejobData.site);
      this.siteId = rawScrapejobData.site.id;
      this.siteImage = rawScrapejobData.site.image;
    }

    this.items = (rawScrapejobData.items || []).map(item => new ItemModel(item));
    this.listings = (rawScrapejobData.listings || []).map(listing => new ListingModel(listing));
  }

  getSideId(): string {
    return this.siteId;
  }

  getSiteName(): string {
    return typeof this.site === 'string' ? this.site : this.site.name;
  }

  getStartTimeFormatted(): string {
    return formatDateTime(this.startTime);
  }

  getEndTimeFormatted(): string {
    return formatDateTime(this.endTime);
  }

  containsArtist(artistId: string): boolean {
    // Check if any listing in this scrapejob has the artist
    const hasMatchingListing = this.listings.some(listing => listing.artistId === artistId);
    // Check if any item in this scrapejob has the artist
    const hasMatchingItem = this.items.some(item => item.artistId === artistId);
    return hasMatchingListing || hasMatchingItem;
  }
}